const resources = {
    footerLabel: 'Clavardage avec le service à la clientèle',
    pageLabel: 'Service à la clientèle',
    buttonLabel: 'Service à la clientèle'
};

export default function getResource(label) {
    return resources[label];
}
